// angular
// 	.module("HeroPRO")
// 	.directive('hpOfficeAddress', officeAddress);

import './officeAddress.scss';

/* @ngInject */
export default function officeAddress(CommonDataFactory) {
    function link(scope) {
        CommonDataFactory.getStates().then((response) => {
            scope.states = response.data.Data;
            scope.selectedState = null;
            for (let i = 0; i < scope.states.length; i++) {
                if (scope.states[i].StateAbbreviation === scope.address.state) {
                    scope.selectedState = scope.states[i];
                }
            }
        });

        scope.stateClicked = function (state) {
		    scope.selectedState = state;
		    scope.address.state = state.StateAbbreviation;
        };
    }

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            address: '=',
            required: '=',
            submitted: '=',
        },
        templateUrl: 'app/accounts/offices/info/address/officeAddress.html',
        link,
    };
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/info/address/hpOfficeAddress.js